// Code generated by gobeyond build; DO NOT EDIT.
import { bootstrapAsync } from '@go-beyond/react/browser'

void bootstrapAsync({ routes: {
  "r_route_8a5edab2": { load: () => import("./routes/r_route_8a5edab2-f1a102fe.js"), pattern: "/" },
  "r_privacy_0ece7f7c": { load: () => import("./routes/r_privacy_0ece7f7c-059b39e4.js"), pattern: "/privacy" },
  "r_terms_2dda5c6b": { load: () => import("./routes/r_terms_2dda5c6b-f8ff4da1.js"), pattern: "/terms" },
} })
